module.exports = __webpack_public_path__ + "img/960-80ab98.png";